import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "Calculatrice de la résistance du conducteur - Calcul de la résistance";
const DESCRIPTION =
  "Calculatrice de la résistance du conducteur - Calcul de la résistance. Calculateur de physique en francais avec resultat rapide, unites claires et aide pratique pour exercices et revisions.";
const KEYWORDS =
  "cundoctor resistance calculator, calculatrice physique, formule physique, exercices de physique, calcul en ligne";
const OG_URL = "https://do-calculate.com/calculator/fr/conductor-resistance";
function ConductorResistanceCalculator() {
  const [length, setLength] = useState("");
  const [crossSection, setCrossSection] = useState("");
  const [resistivity, setResistivity] = useState("");
  const [resistance, setResistance] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    if (!length || !crossSection || !resistivity) {
      setError("Veuillez entrer tous les paramètres correctement");
      setResistance("");
      return;
    }
    const lengthValue = parseFloat(length);
    const crossSectionValue = parseFloat(crossSection);
    const resistivityValue = parseFloat(resistivity);
    if (isNaN(lengthValue) || isNaN(crossSectionValue) || isNaN(resistivityValue) || 
        lengthValue <= 0 || crossSectionValue <= 0 || resistivityValue <= 0) {
      setError("Veuillez entrer des valeurs valides et positives");
      setResistance("");
      return;
    }
    const resistanceValue = (resistivityValue * lengthValue) / crossSectionValue;
    setResistance(resistanceValue.toFixed(4));
    setError("");
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "18px" }}>Comment calculer la résistance du conducteur</h2>
                <p>
                  La résistance d'un conducteur est calculée à partir de sa longueur, de sa section transversale et de sa résistivité selon la formule suivante :
                </p>
                <p>
                  <b>Résistance (Ω) = Résistivité (Ω·m) × Longueur (m) / Section (m²)</b>
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <div dir="ltr">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">Longueur (m)</label>
                      </b>
                      <input
                        type="number"
                        placeholder="10"
                        value={length}
                        onChange={(e) => setLength(e.target.value)}
                        className="form-control"
                        style={{ width: "150px" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">Section (m²)</label>
                      </b>
                      <input
                        type="number"
                        placeholder="0.001"
                        value={crossSection}
                        onChange={(e) => setCrossSection(e.target.value)}
                        className="form-control"
                        style={{ width: "150px" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">Résistivité (Ω·m)</label>
                      </b>
                      <input
                        type="number"
                        placeholder="1.68e-8"
                        value={resistivity}
                        onChange={(e) => setResistivity(e.target.value)}
                        className="form-control"
                        style={{ width: "150px" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        Erreur : {error}
                      </p>
                    ) : (
                      resistance !== "" && (
                        <p className="p-3 mb-2 bg-success text-white">
                          Résistance : {resistance} Ω
                        </p>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <br />
    </div>
  );
}
export default ConductorResistanceCalculator;
